// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"59a31ec49eb20beafbe2","655":"9128a5c2a79b9d82f996"}[chunkId] + ".js";
};